import { getImage } from '../utils';
import { buttonProxy } from './button.proxy';

export function daznBetproxy(component: any): any {
    const componentType = component?.fields?.componentType;
    const entries = component?.fields?.entries[0];
    const title = entries?.fields?.title;
    const description = entries?.fields?.description;
    const buttons = Array.isArray(entries?.fields?.actions) ? entries.fields.actions.map((action: any) => {
        return buttonProxy({
            ...action.fields
        });
    }) : [];

    const backgroundImage = getImage(
        component?.fields?.entries[0]?.fields?.backgroundImage
    );
    console.log('backgroundImage', backgroundImage?.default);

    return {
        componentType,
        title,
        description,
        buttons,
        backgroundImage


    };
}
